import React from "react";
import { Link } from "react-router-dom";
import { Table, Space, Button, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import { SearchRequest } from "../../services/api/interfaces/ApiRequest";
import { SearchOptions } from "../TableHelper";
import { Pagination } from "components/Pagination";

type MappingStateListProps = BaseListComponentProps & {
  loading: boolean;
  mappingStates: any;
  pagination: any;
  filters: any | null;
  history?: any;

  loadMappingStates: (args: SearchRequest) => void;

  onLoad?: (searchOptions: SearchOptions) => void;
};

export default class MappingStateList extends ListComponent<MappingStateListProps> {
  static defaultProps = {
    loading: false,
    mappingStates: [],

    loadMappingStates: () => {},
  };

  tableColumns = [
    {
      title: "Partner",
      dataIndex: "partner_key",
      key: "partner_key",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.partner_key - b.partner_key,
    },
    {
      title: "External Country ID",
      dataIndex: "external_country_id",
      key: "external_country_id",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.external_country_id - b.external_country_id,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name - b.name,
    },
    {
      title: "External ID",
      dataIndex: "external_id",
      key: "external_id",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.external_id - b.external_id,
    },
    {
      title: "Country",
      dataIndex: ["state", "country", "name"],
      key: "country_name",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.state?.country?.name - b.state?.country?.name,
    },
    {
      title: "State",
      dataIndex: ["state", "name"],
      key: "state_uuid",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.state?.name - b.state?.name,
      render: (value: any, record: any) => value ?? record.state_uuid,
    },
    {
      title: 'Shelter',
      dataIndex: ['shelter', 'name'],
      key: 'shelter_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.shelter?.name - b.shelter?.name,
      render: (value: any, record: any, index: number) => record.shelter_id ? value : <Tag children="GLOBAL" />
    },
    {
      title: "Actions",
      key: "action",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link
            to={`state/${record.uuid}`}
            ref={(refs) => this.actionRefs.edit.push(refs)}
          >
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      ),
    },
  ];

  componentDidUpdate(prevProps: any, prevState: any) {
    this.validateAccessPermissions();

    if (prevProps.filters !== this.props.filters) {
      this.load();
    }
  }

  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.filters,
        state: {
          with: {
            _fields: ["id", "uuid", "name", "country_id"],
            country: {
              with: {
                _fields: ["id", "uuid", "name"]
              }
            }
          },
        },
        shelter: {
          with: {
            _fields: ["id", "uuid", "name"]
          },
        },
      },
      options: {
        ...this.searchOptions.options,
        _force_ids: true,
        sort: ["-id"],
      },
    };

    this.props.loadMappingStates(this.searchOptions);

    if (this.props.onLoad) {
      this.props.onLoad(this.searchOptions);
    }
  }

  render() {
    const { loading, pagination, mappingStates, loadMappingStates } = this.props;

    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={mappingStates}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadMappingStates)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={mappingStates?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadMappingStates)
          }
        />
      </>
    );
  }
}
